import Int64LookupResourcePagingResultModel from '../../generated/types/model/resource/Int64LookupResourcePagingResultModel';

export default class Int64LookupResourcePagingResultViewModel extends Int64LookupResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
